import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'components/base';
import useDataContext from 'data/context/data';
import contentApi from 'data/api/content';

import {
  FAVORITE_PRODUCTS,
  // FAVORITE_CATEGORIES,
  // NEW_PRODUCTS,
} from '../specifications/lists';

import { Head, Layout } from '../components/layout';
import HomeCarousel from '../components/custom/homeCarousel';
import {
  NewsletterSection,
  // MottoSection,
  ProductsSection,
  // CategoriesSection,
  BlogSection,
  InstagramSection,
  GetStartedSection,
} from '../components/custom/mainSections';

const HomePage = props => {
  const dataContext = useDataContext();

  const favoriteProducts = dataContext.getProducts(FAVORITE_PRODUCTS);
  // const favoriteCategories = dataContext.getCategories(FAVORITE_CATEGORIES);
  // const newProducts = dataContext.getProducts(NEW_PRODUCTS);

  return (
    <>
      <Head title="Homepage" />

      <Layout>
        <HomeCarousel>
          {props.carousel.map((item, index) => (
            <HomeCarousel.Item
              key={item.key}
              index={index}
              image={item.imageKey}
              buttonLabel={item.buttonCaption}
              href={item.linkUrl}
            >
              <Typography.H2>{item.caption}</Typography.H2>
              <Typography.H3 className="text-black mb-5">{item.description}</Typography.H3>
            </HomeCarousel.Item>
          ))}
        </HomeCarousel>

        <ProductsSection title="POPULAR" products={favoriteProducts} xs={6} md={4} />

        <GetStartedSection />

        {/* <MottoSection
          type="blue"
          label="MyCanvas mission statement"
          motto="MyCanvas brings people together. We help bond generations by turning family history into art, books and gifts that bring your past into the present."
        /> */}

        {/* <CategoriesSection title="CATEGORIES" categories={favoriteCategories} xs={6} /> */}

        {/* <ProductsSection title="NEW ARRIVALS" products={newProducts} xs={6} md={3} /> */}

        <InstagramSection />

        {props.blog.length > 0 && <BlogSection data={props.blog} />}

        <NewsletterSection className="mt-5" />
      </Layout>
    </>
  );
};

HomePage.getInitialProps = async () => {
  const carousel = await contentApi.carousel();
  const blog = await contentApi.blog();

  return {
    carousel,
    blog,
  };
};

HomePage.propTypes = {
  carousel: PropTypes.array,
  blog: PropTypes.array,
};

export default HomePage;
